import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { TwoFactorEnabledComponent } from './two.factor.enabled/two.factor.enabled.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, ModalModule.forRoot()],
  providers: [],
  schemas: [],
  declarations: [TwoFactorEnabledComponent],
  exports: [TwoFactorEnabledComponent],
})
export class TwoFAModule {}
